import { memo, useEffect, useState } from "react";
import Loading from "../Loading/Loading";
import { Droppable } from "react-beautiful-dnd";
import styles from "./FlagsMenu.module.css";
import { Checkbox, Input, Modal, Select, message } from "antd";
import FlagMapper, { FlagTypes } from "../../Util/FlagMapper";
import Flag from "../Flag/Flag";
import api from "../../api/api";

const FlagsMenu = ({
  flags,
  relatedFlagsList = [],
  flagsHistory = {},
  operatorData = {},
  checkIsRemoved,
  roadmapId,
  globalSearch,
  className,
  getIgnoreFlagsBaseOnTag,
  getIgnoreFlagsSingle,
  showRelatedFlags = false,
  setShowRelatedFlags = () => {},
  checkIsDeletedFlag = () => false,
  flagCategory = "all",
  setFlagCategory = () => {},
  segment = "all",
  setSegment = () => {},
}) => {
  const [showNewFlags, setShowNewFlags] = useState(false);
  const [showConnectedFlags, setShowConnectedFlags] = useState(false);
  const [flagsConnectionReport, setFlagsConnectionReport] = useState([]);
  const [flagSearch, setFlagSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [descFlag, setDescFlag] = useState({});
  const [allFlagsCategory, setAllFlagsCategory] = useState([]);

  const getFlagCategories = () => {
    api
      .get("/flags/category")
      .then((res) => setAllFlagsCategory(res.data))
      .catch(() => message.error("خطا در دریافت دسته بندی ها"));
  };

  const getDeleteOperator = (flagId) => {
    if (!flagsHistory) return null;

    return flagsHistory[+flagId]
      ?.filter((his) => his.operate === "remove")
      ?.at(-1)?.user;
  };

  const sortFlags = (fls) => {
    const removedFlags = fls?.filter((fl) => checkIsRemoved(fl.id)) ?? [];
    const nonRemovedFlags = fls?.filter((fl) => !checkIsRemoved(fl.id)) ?? [];

    return [...removedFlags, ...nonRemovedFlags];
  };

  const getFlagsReport = () => {
    api
      .get("/flags/report", { params: { dataCond: false } })
      .then(({ data }) => {
        setFlagsConnectionReport(data.connectedFlagsInAllForms);
      });
  };

  useEffect(() => {
    getFlagCategories();
    getFlagsReport();
  }, []);
  useEffect(() => {
    console.log("menu", flags);
  }, [flags]);

  return (
    <>
      <Modal
        title={descFlag.title}
        open={showModal}
        onCancel={() => setShowModal(false)}
        destroyOnClose
        footer={[]}
      >
        <p
          style={{
            minHeight: "10rem",
            border: "1px solid rgba(0,0,0,0.3)",
            borderRadius: "0.2rem",
            padding: "0.5rem",
          }}
        >
          {descFlag.description}
        </p>
      </Modal>

      <Droppable droppableId="flags">
        {(provided) => {
          return (
            <div
              className={[styles.FlagsMenu, className].join(" ")}
              style={{ height: "calc(100vh - 12rem)" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                }}
              >
                <h1 className={styles.FlagsTitle}>کارت ها</h1>
                <Input
                  style={{ width: "60%" }}
                  value={flagSearch}
                  placeholder="جستجو ..."
                  onChange={(e) => {
                    setFlagSearch(e.target.value);
                  }}
                />
              </div>

              {/* filters */}
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  paddingBottom: "0.7rem",
                  flexWrap: "wrap",
                }}
              >
                {/* show / hidden */}
                <Select
                  style={{ width: "100%" }}
                  value={segment}
                  onChange={(val) => setSegment(val)}
                  options={[
                    { label: "همه", value: "all" },
                    ...FlagTypes.map((type) => {
                      return {
                        label: FlagMapper(type).title,
                        value: type,
                      };
                    }),
                    { label: "عدم نمایش", value: "not_show" },
                  ]}
                />

                {/* category */}
                <Select
                  defaultValue="all"
                  style={{ width: "100%", marginTop: "0.5rem" }}
                  mode="multiple"
                  onChange={(selectedArray) => {
                    setFlagCategory(selectedArray);
                  }}
                >
                  {[
                    {
                      text: "همه",
                      value: "all",
                    },
                    ...allFlagsCategory.map((fl) => ({
                      text: fl,
                      value: fl,
                    })),
                  ]?.map((el) => (
                    <Select.Option value={el.value} key={el.value}>
                      {el.text}
                    </Select.Option>
                  ))}
                </Select>

                <div>
                  <Checkbox
                    style={{ padding: "0.5rem", paddingBottom: "0rem" }}
                    checked={showRelatedFlags}
                    onChange={(e) => setShowRelatedFlags(e.target.checked)}
                  >
                    نمایش کارت های مرتبط
                  </Checkbox>

                  <Checkbox
                    checked={showNewFlags}
                    onChange={(e) => setShowNewFlags(e.target.checked)}
                  >
                    نمایش کارت‌های جدید
                  </Checkbox>

                  <Checkbox
                    checked={showConnectedFlags}
                    onChange={(e) => setShowConnectedFlags(e.target.checked)}
                  >
                    نمایش کارت‌های غیر متصل
                  </Checkbox>
                </div>
              </div>

              <div
                className={styles.FlagsContainer}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {Array.isArray(flags) && roadmapId ? (
                  sortFlags(flags)
                    // filter category
                    .filter((fl) => {
                      if (flagCategory.includes("all")) return true;

                      return flagCategory.every((e) =>
                        fl?.flagCategory.includes(e)
                      );
                    })
                    // filter connected
                    .filter((fl) => {
                      if (!showConnectedFlags) return true;
                      return !flagsConnectionReport.includes(fl.id);
                    })
                    // filter segment
                    .filter((fl) => {
                      if (segment === "all") return true;

                      return fl?.type?.includes(segment);
                    })
                    // filter name
                    .filter((fl) => {
                      if (fl.title?.trim() === "") return true;

                      return fl.title.includes(flagSearch);
                    })
                    .filter((fl) => {
                      if (
                        !showRelatedFlags ||
                        !getIgnoreFlagsBaseOnTag ||
                        !getIgnoreFlagsSingle
                      ) {
                        return true;
                      }

                      const { shouldRemoveFlagsId } = getIgnoreFlagsBaseOnTag();
                      const ignoreBaseOnQa = getIgnoreFlagsSingle();

                      return (
                        !shouldRemoveFlagsId.includes(fl.id) &&
                        !ignoreBaseOnQa.includes(fl.id)
                      );
                    })
                    .map((el, index) => {
                      if (!el) return null;
                      const deletedBy = getDeleteOperator(el.id);
                      return el ? (
                        <Flag
                          roadmapLimiterOnHistory={checkIsDeletedFlag(el.id)}
                          flagRef={el}
                          renderFromFlagsMenu={true}
                          operatorData={operatorData}
                          deletedBy={deletedBy}
                          supervisorConfirm={el.supervisorConfirm}
                          removeOrAdd={checkIsRemoved(el.id)}
                          onEdit={() => {
                            setDescFlag(el);
                            setShowModal(true);
                          }}
                          {...el}
                          key={el.id}
                          index={index}
                          active={
                            `${el.description} | ${el.title}`.includes(
                              `${globalSearch}`
                            ) || `${globalSearch}`.trim() === ""
                          }
                        />
                      ) : null;
                    })
                ) : (
                  <Loading />
                )}
              </div>
              {provided.placeholder}
            </div>
          );
        }}
      </Droppable>
    </>
  );
};
export default memo(FlagsMenu);
